import { ReactElement, useState } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { CreateAdmin } from '..';

export type CreateAdminButtonProps = {};
export function CreateAdminButton(props: CreateAdminButtonProps): ReactElement {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				icon="add"
				onClick={() => {
					setIsOpen(true);
				}}
			>
				Create admin
			</Button>
			<Dialog isOpen={isOpen}>
				<div className={Classes.DIALOG_BODY}>
					<CreateAdmin />
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							onClick={() => {
								setIsOpen(false);
							}}
						>
							Close
						</Button>
					</div>
				</div>
			</Dialog>
		</>
	);
}
